import moment from 'moment';
import 'moment/locale/pt-br';

function GetDay() {
    return moment(new Date()).format("yyyy-MM-DD");
}

function GetYesterday() {
    return moment().subtract(1, 'days').format('yyyy-MM-DD');
}

function GetWeek() {
    const start = moment().startOf('week').format('yyyy-MM-DD');
    const end = moment().endOf('week').format('yyyy-MM-DD');
    return { start, end };
}

function GetMonth() {
    const start = moment().startOf('month').format('yyyy-MM-DD');
    const end = moment().endOf('month').format('yyyy-MM-DD');
    return { start, end };
}

function GetYear() {
    const start = moment().startOf('year').format('yyyy-MM-DD');
    const end = moment().endOf('year').format('yyyy-MM-DD');
    return { start, end };
}

function getUnderEighteen(date: Date | string): Date | null {
    if (!date)
        return null;
    const d = new Date(date);
    if (!d)
        return null;
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const dateUder = new Date(year + 18, month, day);
    return dateUder;
}

function read(date: string, time: boolean = true) {
    return moment(date).format(`DD/MMM/YYYY${time ? ' HH:mm' : ''}`);
}

function getDiff(firstDate: Date, endDate: Date) {
    return endDate.getTime() - firstDate.getTime();
}

function getCurrentDay() {
    return moment().format('DD');
}

const formatDateAndTime = (dateString:string) => {
  const date = new Date(dateString);
  
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Formato 24h
  }).format(date);
};

const convertFormatDate = (date:string, formatActual:string | moment.MomentBuiltinFormat, formatNew:string) =>{
    if (/^\d{4}-\d{2}-\d{2}T/.test(date)) {
        return date.substring(0, 10); 
    }
    const dateMoment = moment(date, formatActual);
    return dateMoment.format(formatNew);
};
const isValidDateBR = (dateString: string) => {
    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

    const match = dateString.match(regex);

    if (!match) {
        return false;
    }

    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    // cria data
    const date = new Date(year, month - 1, day);

    // valida se a data realmente existe
    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
}

const HelperDate = {
    getUnderEighteen,
    GetDay,
    GetYesterday,
    GetWeek,
    GetMonth,
    GetYear,
    read,
    getDiff,
    getCurrentDay,
    formatDateAndTime,
    convertFormatDate,
    isValidDateBR
}

export default HelperDate;